
import axios from 'axios'


function getAlarms(pointId) {
    return axios.get(`${process.env.VUE_APP_APIURL}/point/${pointId}/frequencyPeakAlarm`).then(res => {
        return res.data.map(alarm => {
            return {
                _id: alarm._id,
                threshold: alarm.threshold,
                sensitivity: alarm.sensitivity * 2,
                point: alarm.point,
                frequency: alarm.frequency,
                customer: alarm.customer,
                createdAt: alarm.createdAt,
                axis: alarm.axis,
                name: alarm.name
            };
        })
    })
}

function saveAlarms(pointId, alarm) {
    let alarms = alarm.map(alarm => {
        return {
            threshold: alarm.threshold,
            sensitivity: alarm.sensitivity / 2,
            frequency: alarm.frequency,
            axis: alarm.axis,
            name: alarm.name
        }})
    return axios.post(`${process.env.VUE_APP_APIURL}/point/${pointId}/frequencyPeakAlarm`, {alarms}).then(res => {
        return res.data
    })
}


export default {
    getAlarms,
    saveAlarms,
};